module.exports = __webpack_public_path__ + "img/9.10a1b5b5.png";